import React from 'react'
import PropTypes from 'prop-types'

const PendingDetails = (props) => {
    return props.items.map((item, key) => {
        if (item.value) {
            return (
                <div
                    key={key}
                    className='pending-detail mx-lg-4 mb-md-0 flex-grow-1'
                >
                    <div className='pb-1'>{item.title}</div>
                    <div className='bold' dangerouslySetInnerHTML={{ __html: item.value }} />
                </div>
            )
        }
    })
}

PendingDetails.propTypes = {
    items: PropTypes.array.isRequired
}

export default PendingDetails



// WEBPACK FOOTER //
// ./resources/js/components/PendingDetails.js